import Cookies from "react-cookies";
import jwtDecode from "jwt-decode";

import { parseProfile } from "./../../helpers/profile";

import {
    UserCookieVar,
    UserCookieVarId,
    UserCookieVarProfile,
    UserCookieVarProfileFeedback,
    UserCookieVarConsent,
    UserVarCampaignData,
    UserCampaignDataFields,
    UserCookieVarProfilePhoto,
    UserCookieVarEKYCViewed,
    UserCookieReferralCode,
    UserCookieVarProfileAdditionalInfo,
} from "./../../const/user";

export default class User {
    static get() {
        const user = Cookies.load(UserCookieVar) || false;

        return user;
    }

    static set(tokenData) {
        const { AccessToken: accessToken, RefreshToken: refreshToken, ExpiresIn: maxAge } = tokenData;

        const user = jwtDecode(accessToken);
        const { username: userID } = user;

        const userCookies = {
            "access-token": accessToken,
            "refresh-token": refreshToken,
            "user-id": userID,
        };

        Cookies.save(UserCookieVar, userCookies, { maxAge: maxAge * 1.25, path: "/" });
        Cookies.save(UserCookieVarId, userID, { maxAge: maxAge * 1.25, path: "/" });
    }

    static unset() {
        Cookies.remove(UserCookieVar, { path: "/" });
        Cookies.remove(UserCookieVarId, { path: "/" });
    }

    static getProfile() {
        let profile = Cookies.load(UserCookieVarProfile) || false;

        if (typeof profile === "object" && profile) {
            profile["borrowerAdditionalInfo"] = this.getProfileAdditionalInfo();

            if (!profile["representative-first-name"] || !profile["representative-last-name"]) {
                profile = false;
            }
        }

        return profile;
    }

    static saveProfile(profile, maxAge = 3600) {
        const {
            "borrower_family_name": borrowerFamilyName,
            "borrower_given_name": borrowerGivenName,
            "borrower_middle_name": borrowerMiddleName,
            "borrower_suffix": borrowerSuffix,
            "business_name": businessName,
            "borrower_email": borrowerEmail,
            "borrower_referral_code": borrowerReferralCode,
            "borrower_campaign_data": campaignData,
            "borrower_birthdate": borrowerBirthdate,
            "business_province": businessProvince,
            "profile_completion": profileCompletion,
            microfeedback = {},
            "borrower_additional_info": borrowerAdditionalInfo = {},
            "ekyc_status": ekycStatus = false,
            "borrower_mobile_number": borrowerMobileNumber,
        } = profile;

        const parsedProfile = parseProfile({
            "borrower_family_name": borrowerFamilyName,
            "borrower_given_name": borrowerGivenName,
            "borrower_middle_name": borrowerMiddleName,
            "borrower_suffix": borrowerSuffix,
            "business_name": businessName,
            "borrower_email": borrowerEmail,
            "borrower_referral_code": borrowerReferralCode,
            "borrower_birthdate": borrowerBirthdate,
            "business_province": businessProvince,
            "borrower_mobile_number": borrowerMobileNumber,
        });

        this.setProfile({ ...parsedProfile, ...{ campaignData, profileCompletion, ekycStatus } }, maxAge);
        this.setProfileAdditionalInfo(borrowerAdditionalInfo);
        this.setProfileFeedback(microfeedback, maxAge);
    }

    static setProfile(profile, maxAge = 3600) {
        Cookies.save(UserCookieVarProfile, profile, { maxAge, path: "/" });
    }

    static getProfileAdditionalInfo() {
        const additionalInfo = JSON.parse(window.localStorage.getItem(UserCookieVarProfileAdditionalInfo)) || {};
        return additionalInfo;
    }

    static setProfileAdditionalInfo(additionalInfo) {
        window.localStorage.setItem(UserCookieVarProfileAdditionalInfo, JSON.stringify(additionalInfo));
    }

    static unsetProfileAdditionalInfo() {
        window.localStorage.removeItem(UserCookieVarProfileAdditionalInfo);
    }

    static getProfileFeedback() {
        let feedback = window.localStorage.getItem(UserCookieVarProfileFeedback) || false;
        if (feedback) {
            feedback = JSON.parse(feedback);
        }

        return feedback;
        // return Cookies.load(UserCookieVarProfileFeedback) || false;
    }

    static setProfileFeedback(profileFeedback, maxAge = 3600) {
        let { app_form: appForm = [] } = profileFeedback;

        if (!appForm) {
            appForm = [];
        }

        const filteredAppForms = [];
        appForm.forEach((loanApp) => {
            if (loanApp) {
                if (!filteredAppForms.includes(loanApp)) {
                    filteredAppForms.push(loanApp);
                }
            }
        });

        profileFeedback["app_form"] = filteredAppForms;

        window.sessionStorage.setItem(UserCookieVarProfileFeedback, JSON.stringify(profileFeedback));
        // Cookies.save(UserCookieVarProfileFeedback, profileFeedback, { maxAge, path: "/" });
    }

    static unsetProfileFeedback() {
        window.sessionStorage.removeItem(UserCookieVarProfileFeedback);
        // Cookies.remove(UserCookieVarProfileFeedback, { path: "/" });
    }

    static getProfilePhoto() {
        const avatar = Cookies.load(UserCookieVarProfilePhoto) || false;

        return avatar;
    }

    static setProfilePhoto(image, maxAge = 3600) {
        const profilePhoto = { "avatar": image };
        Cookies.save(UserCookieVarProfilePhoto, profilePhoto, { maxAge, path: "/" });
    }

    static unsetProfilePhoto() {
        Cookies.remove(UserCookieVarProfilePhoto, { path: "/" });
    }

    static unsetProfile() {
        Cookies.remove(UserCookieVarProfile, { path: "/" });
    }

    static getCampaignData() {
        // let campaignData = Cookies.load(UserVarCampaignData) || false;
        let campaignData = JSON.parse(window.sessionStorage.getItem(UserVarCampaignData)) || false;

        if (campaignData) {
            if (Object.keys(campaignData).length === 0) {
                campaignData = false;
            }
        }

        return campaignData;
    }

    static saveCampaignData(search) {
        if (!search || search === "") {
            return false;
        }

        const params = new URLSearchParams(search);
        let campaignData = {};

        UserCampaignDataFields.forEach((item) => {
            if (params.has(item) && params.get(item) !== "") {
                campaignData[item] = params.get(item);
            }
        });

        if (Object.keys(campaignData).length === 0) {
            return false;
        }

        this.setCampaignData(campaignData);

        return true;
    }

    static setCampaignData(campaignData) {
        // Cookies.save(UserVarCampaignData, campaignData, { maxAge });
        window.sessionStorage.setItem(UserVarCampaignData, JSON.stringify(campaignData));
    }

    static unsetCampaignData() {
        // Cookies.remove(UserVarCampaignData);
        // console.log("UNSET CAMPAIGN");
        window.sessionStorage.removeItem(UserVarCampaignData);
    }

    static getConsent(name) {
        return Cookies.load(`${UserCookieVarConsent}-${name}`) ? true : false;
    }

    static setConsent(name, maxAge = 86400) {
        Cookies.save(`${UserCookieVarConsent}-${name}`, "yes", { maxAge, path: "/" });
    }

    static getEKYCViewed() {
        return Cookies.load(UserCookieVarEKYCViewed) || false;
    }

    static setEKYCViewed() {
        Cookies.save(UserCookieVarEKYCViewed, "yes", { path: "/" });
    }

    static saveReferralCode(code, maxAge = 3600) {
        Cookies.save(UserCookieReferralCode, code, { maxAge, path: "/" });
    }

    static getReferralCode() {
        const referralCode = Cookies.load(UserCookieReferralCode) || false;

        return referralCode;
    }

    static unsetReferralCode() {
        Cookies.remove(UserCookieReferralCode, { path: "/" });
    }
}
